<template>
  <v-container>
    <v-row class="justify-center">
      <v-col cols="12" class="text-center mt-8">
        <heart-loader />
        <h4 class="py-4">Logging you in...</h4>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col cols="4" class="text-center">
        <a href="#" @click.prevent="logout">Stuck? Click here to try again</a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HeartLoader from "@/components/HeartLoader"

export default {
  name: 'OAuthCallbackView',

  components: {
    HeartLoader,
  },

  data() {
    return {
      authorizationCode: null,
      clientId: 'eQfycs5zGlkhajIXy6yZszZviLkK1da3YLIcQwQS',
    }
  },

  computed: {
    challenge() {
      return this.$store.state.challenge
    }
  },

  methods: {
    logout() {
      window.localStorage.removeItem('vuex')
      window.location.href = 'https://challenge.rayoga.com&prompt=1'
    },
  },

  mounted() {
    /*this.$nextTick(() => {
      this.$store.state.code = this.$route.query.code
      this.$store.dispatch('authenticate')
    })*/
    this.$store.state.code = this.$route.query.code
    this.$store.dispatch('authenticate')
  }
}
</script>

<style lang="sass" scoped>
</style>